// extracted by mini-css-extract-plugin
export default {"work_section":"Projects_work_section__qG7QZ","heading":"Projects_heading__Rhi5W","container":"Projects_container__Z7iZX","title":"Projects_title__Npx-v"};